import { render, staticRenderFns } from "./AlfPlaces.vue?vue&type=template&id=507cf1de&scoped=true&"
import script from "./AlfPlaces.vue?vue&type=script&lang=js&"
export * from "./AlfPlaces.vue?vue&type=script&lang=js&"
import style0 from "./AlfPlaces.vue?vue&type=style&index=0&id=507cf1de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507cf1de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('507cf1de')) {
      api.createRecord('507cf1de', component.options)
    } else {
      api.reload('507cf1de', component.options)
    }
    module.hot.accept("./AlfPlaces.vue?vue&type=template&id=507cf1de&scoped=true&", function () {
      api.rerender('507cf1de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/places/AlfPlaces.vue"
export default component.exports